export default class RoleHelper {
    static ACTION_DOWNLOAD = "downloadDocuments";
    static ACTION_DOWNLOADWEBPORTAL = "downloadWebPortalDocuments";
    static ACTION_SCHEDULE = "scheduleDownload";

    static DOCUMENT_TYPE_EMITIDOS = "emision";
    static DOCUMENT_TYPE_RECIBIDOS = "recepcion";

    static TYPE_INGRESO = "I";
    static TYPE_ENGRESO = "E";
    static TYPE_NOMINA = "I";
    static TYPE_PAGO = "P";
    static TYPE_TRASLADO = "T";

    constructor(roleConfig) {
        if (!roleConfig) return;
        this.idRole = roleConfig.idRole;
        this.roleName = roleConfig.roleName;
        this.config = roleConfig.config;
    }

    hasAllOptions(actionType, documentType) {
        if (!this.config) return true;
        let accessObject = this.config;

        accessObject = accessObject[actionType];
        if (!accessObject) return false;

        if (!documentType) return true;
        accessObject = accessObject[documentType];

        return accessObject && accessObject.length === 5;
    }

    hasAccess(actionType, documentType, type) {
        if (!this.config) return true;
        let accessObject = this.config;

        accessObject = accessObject[actionType];
        if (!accessObject) return false;

        if (!documentType) return true;
        accessObject = accessObject[documentType];
        if (!accessObject) return false;

        if (!type) return true;
        return accessObject.includes(type);
    }
}